<template>
  <v-tour name="obt" :steps="steps" :callbacks="onboardingCallbacks"></v-tour>
</template>

<script setup lang="ts">
import { TourEventBus } from "../event-bus";
import { Step, Tour } from "vue3-tour";
import tourCallbacks from "./onboarding-callbacks";
import { getCurrentInstance, nextTick, onBeforeUnmount, onMounted, ref } from "vue";

const onboardingCallbacks = ref(tourCallbacks);
const steps = ref([]);

const internalInstance = getCurrentInstance();
const $tours: Record<string, Tour> = internalInstance.appContext.config.globalProperties.$tours;

const startOnboardingHandler = (guide: Step[]) => {
  steps.value = guide;
  nextTick(() => {
    $tours["obt"].start();
  });
};

const stopOnboardingHandler = () => {
  steps.value = [];
};

onMounted(() => {
  TourEventBus.on("startOnboarding", startOnboardingHandler);
  TourEventBus.on("stopOnboarding", stopOnboardingHandler);
});

onBeforeUnmount(() => {
  TourEventBus.off("startOnboarding", startOnboardingHandler);
  TourEventBus.off("stopOnboarding", stopOnboardingHandler);
});
</script>

<style></style>
